const TOKEN_KEY = 'bp_hub_token'
const USER_KEY = 'bp_hub_user'

export type StoredUser = {
  id: number
  nome: string
  id_permissao: number
  campanha_id: number
  campanha_nome: string
}

function storageGet(key: string): string | null {
  try {
    return localStorage.getItem(key)
  } catch {
    /* Safari privado / ITP */
    return null
  }
}

function storageSet(key: string, value: string): void {
  try {
    localStorage.setItem(key, value)
  } catch {
    /* ignore */
  }
}

function storageRemove(key: string): void {
  try {
    localStorage.removeItem(key)
  } catch {
    /* ignore */
  }
}

export function getToken(): string | null {
  return storageGet(TOKEN_KEY)
}

export function setAuth(token: string, user: StoredUser): void {
  storageSet(TOKEN_KEY, token)
  storageSet(USER_KEY, JSON.stringify(user))
}

export function clearAuth(): void {
  storageRemove(TOKEN_KEY)
  storageRemove(USER_KEY)
  try {
    // Lazy import evita ciclo auth ↔ api
    void import('./hubShellCache').then((m) => m.invalidateHubShellCache())
  } catch {
    /* ignore */
  }
}

export function getStoredUser(): StoredUser | null {
  const raw = storageGet(USER_KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw) as StoredUser
  } catch {
    return null
  }
}

export function isLideranca(user: StoredUser | null = getStoredUser()): boolean {
  return (user?.id_permissao ?? 0) === 1
}
